var React = require('react');

function IcUpgradeCircle (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"upgrade_circle","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"ic-upgrade-circle"},[React.createElement("circle",{"id":"Oval","fill":"#1B2229","cx":"11","cy":"11","r":"11","key":0}),React.createElement("path",{"d":"M5,12.326087 L11,4.5 L17,12.326087 L13.0571429,12.326087 L13.0571429,16.5 L8.94285714,16.5 L8.94285714,12.326087 L5,12.326087 Z","id":"arrow","fill":"#FFFFFF","key":1})])));
}

IcUpgradeCircle.defaultProps = {"width":"22px","height":"22px","viewBox":"0 0 22 22","version":"1.1"};

module.exports = IcUpgradeCircle;

IcUpgradeCircle.default = IcUpgradeCircle;
